import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Box, Paper, Snackbar, TableCell, TableContainer } from "@mui/material";
import { Stack } from "@mui/material";
import { TableRow } from "@mui/material";
import { Alert } from "../../../Components/Alert/Alert";
import { StyledTableCell, StyledTableCellRight, StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomSelect, CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { nutriente } from "../../../informacao_estatica";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import BasicPopover from "../../../Components/Popover";
import { IPlanoFertil1, IPlanoFertil2, IPlanoFertil3 } from "../../../Interfaces/anexos/anexo1/plano_fertil1_4";
import { del, get, post } from "../../../Services/tokenConfig";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { func_print } from "../../../Func_genericas/func_print";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
}


export const PlanoFertlizante2Form: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado }) => {
    const auth = useContext(AuthContext);
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [createTable, setCreateTable] = useState(false);
    const [flag_criar_cabecalho, set_flag_criar_cabecalho] = useState(false);
    const [flag_criar_anexo_3, set_flag_criar_anexo_3] = useState(false);

    const [message, setMessage] = useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);
    const [obj_anexo, set_obj_anexo] = useState<IPlanoFertil2>();
    const [obj_anexo_lista, set_obj_anexo_lista] = useState<IPlanoFertil2[]>([]);
    const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<IPlanoFertil1>();
    const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<IPlanoFertil1[]>([]);
    const [error_fonte_nutri_camp1, seterror_fonte_nutri_camp1] = useState(false);
    const [error_fonte_nutri_camp2, seterror_fonte_nutri_camp2] = useState(false);
    const [error_fonte_nutri_camp3, seterror_fonte_nutri_camp3] = useState(false);
    const [error_fonte_nutri_camp4, seterror_fonte_nutri_camp4] = useState(false);
    const [error_fonte_nutri_camp5, seterror_fonte_nutri_camp5] = useState(false);
    const [error_fonte_nutri_camp6, seterror_fonte_nutri_camp6] = useState(false);
    const [error_fonte_nutri_camp7, seterror_fonte_nutri_camp7] = useState(false);
    const [error_fonte_nutri_camp8, seterror_fonte_nutri_camp8] = useState(false);

    const [error_a_um_camp1, set_error_a_um_camp1] = useState(false);
    const [error_a_um_camp2, set_error_a_um_camp2] = useState(false);
    const [error_a_um_camp3, set_error_a_um_camp3] = useState(false);
    const [error_a_um_camp4, set_error_a_um_camp4] = useState(false);
    const [error_a_um_camp5, set_error_a_um_camp5] = useState(false);
    const [error_a_um_camp6, set_error_a_um_camp6] = useState(false);
    const [error_a_um_camp7, set_error_a_um_camp7] = useState(false);
    const [error_a_um_camp8, set_error_a_um_camp8] = useState(false);
    const [error_a_dois_camp1, set_error_a_dois_camp1] = useState(false);
    const [error_a_dois_camp2, set_error_a_dois_camp2] = useState(false);
    const [error_a_dois_camp3, set_error_a_dois_camp3] = useState(false);
    const [error_a_dois_camp4, set_error_a_dois_camp4] = useState(false);
    const [error_a_dois_camp5, set_error_a_dois_camp5] = useState(false);
    const [error_a_dois_camp6, set_error_a_dois_camp6] = useState(false);
    const [error_a_dois_camp7, set_error_a_dois_camp7] = useState(false);
    const [error_a_dois_camp8, set_error_a_dois_camp8] = useState(false);
    const [error_a_tres_camp1, set_error_a_tres_camp1] = useState(false);
    const [error_a_tres_camp2, set_error_a_tres_camp2] = useState(false);
    const [error_a_tres_camp3, set_error_a_tres_camp3] = useState(false);
    const [error_a_tres_camp4, set_error_a_tres_camp4] = useState(false);
    const [error_a_tres_camp5, set_error_a_tres_camp5] = useState(false);
    const [error_a_tres_camp6, set_error_a_tres_camp6] = useState(false);
    const [error_a_tres_camp7, set_error_a_tres_camp7] = useState(false);
    const [error_a_tres_camp8, set_error_a_tres_camp8] = useState(false);

    const [obj_anexo_3, set_obj_anexo_3] = useState<IPlanoFertil3>();
    const [obj_anexo_lista_3, set_obj_anexo_lista_3] = useState<IPlanoFertil3[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
    const [open_dialog_tem_a_certeza_que_quer_eliminar_3, set_open_dialog_tem_a_certeza_que_quer_eliminar_3] = useState(false);
    const [open_dialog_tem_a_certeza_que_quer_eliminar_cabecalho, set_open_dialog_tem_a_certeza_que_quer_eliminar_cabecalho] = useState(false);

    const [existe_cabecalho, set_existe_cabecalho] = useState(false)

    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

    const [flag_editado_cabecalho, set_flag_editado_cabecalho] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_cabecalho, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_cabecalho] = React.useState(false);

    const [flag_editado_3, set_flag_editado_3] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_3, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_3] = React.useState(false);


    const handle_criar_anexo = async () => {
        if (error_fonte_nutri_camp1 || error_fonte_nutri_camp2 || error_fonte_nutri_camp3 || error_fonte_nutri_camp4 || error_fonte_nutri_camp5 || error_fonte_nutri_camp6 || error_fonte_nutri_camp7 || error_fonte_nutri_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_plano_ferti_um", {
                    payload: {
                        id_plano_dois: 0,
                        fonte_nutri: obj_anexo?.fonte_nutri === undefined ? '' : obj_anexo?.fonte_nutri,
                        fonte_nutri_camp1: obj_anexo?.fonte_nutri_camp1 === undefined ? null : obj_anexo?.fonte_nutri_camp1,
                        fonte_nutri_camp2: obj_anexo?.fonte_nutri_camp2 === undefined ? null : obj_anexo?.fonte_nutri_camp2,
                        fonte_nutri_camp3: obj_anexo?.fonte_nutri_camp3 === undefined ? null : obj_anexo?.fonte_nutri_camp3,
                        fonte_nutri_camp4: obj_anexo?.fonte_nutri_camp4 === undefined ? null : obj_anexo?.fonte_nutri_camp4,
                        fonte_nutri_camp5: obj_anexo?.fonte_nutri_camp5 === undefined ? null : obj_anexo?.fonte_nutri_camp5,
                        fonte_nutri_camp6: obj_anexo?.fonte_nutri_camp6 === undefined ? null : obj_anexo?.fonte_nutri_camp6,
                        fonte_nutri_camp7: obj_anexo?.fonte_nutri_camp7 === undefined ? null : obj_anexo?.fonte_nutri_camp7,
                        fonte_nutri_camp8: obj_anexo?.fonte_nutri_camp8 === undefined ? null : obj_anexo?.fonte_nutri_camp8,
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista((old) => [...old, data.data.result])
                    set_obj_anexo(undefined)
                    setCreateTable(false)
                    set_flag_editado(false)
                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }
    const handle_criar_anexo_3 = async () => {
        if (error_a_um_camp1 ||
            error_a_um_camp2 ||
            error_a_um_camp3 ||
            error_a_um_camp4 ||
            error_a_um_camp5 ||
            error_a_um_camp6 ||
            error_a_um_camp7 ||
            error_a_um_camp8 ||


            error_a_dois_camp1 ||
            error_a_dois_camp2 ||
            error_a_dois_camp3 ||
            error_a_dois_camp4 ||
            error_a_dois_camp5 ||
            error_a_dois_camp6 ||
            error_a_dois_camp7 ||
            error_a_dois_camp8 ||

            error_a_tres_camp1 ||
            error_a_tres_camp2 ||
            error_a_tres_camp3 ||
            error_a_tres_camp4 ||
            error_a_tres_camp5 ||
            error_a_tres_camp6 ||
            error_a_tres_camp7 ||
            error_a_tres_camp8

        ) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_plano_ferti_dois", {
                    payload: {
                        id_plano_tres: 0,
                        a_um_camp1: obj_anexo_3?.a_um_camp1 === undefined ? null : obj_anexo_3?.a_um_camp1.toString(),
                        a_um_camp2: obj_anexo_3?.a_um_camp2 === undefined ? null : obj_anexo_3?.a_um_camp2.toString(),
                        a_um_camp3: obj_anexo_3?.a_um_camp3 === undefined ? null : obj_anexo_3?.a_um_camp3.toString(),
                        a_um_camp4: obj_anexo_3?.a_um_camp4 === undefined ? null : obj_anexo_3?.a_um_camp4.toString(),
                        a_um_camp5: obj_anexo_3?.a_um_camp5 === undefined ? null : obj_anexo_3?.a_um_camp5.toString(),
                        a_um_camp6: obj_anexo_3?.a_um_camp6 === undefined ? null : obj_anexo_3?.a_um_camp6.toString(),
                        a_um_camp7: obj_anexo_3?.a_um_camp7 === undefined ? null : obj_anexo_3?.a_um_camp7.toString(),
                        a_um_camp8: obj_anexo_3?.a_um_camp8 === undefined ? null : obj_anexo_3?.a_um_camp8.toString(),

                        a_dois_camp1: obj_anexo_3?.a_dois_camp1 === undefined ? null : obj_anexo_3?.a_dois_camp1.toString(),
                        a_dois_camp2: obj_anexo_3?.a_dois_camp2 === undefined ? null : obj_anexo_3?.a_dois_camp2.toString(),
                        a_dois_camp3: obj_anexo_3?.a_dois_camp3 === undefined ? null : obj_anexo_3?.a_dois_camp3.toString(),
                        a_dois_camp4: obj_anexo_3?.a_dois_camp4 === undefined ? null : obj_anexo_3?.a_dois_camp4.toString(),
                        a_dois_camp5: obj_anexo_3?.a_dois_camp5 === undefined ? null : obj_anexo_3?.a_dois_camp5.toString(),
                        a_dois_camp6: obj_anexo_3?.a_dois_camp6 === undefined ? null : obj_anexo_3?.a_dois_camp6.toString(),
                        a_dois_camp7: obj_anexo_3?.a_dois_camp7 === undefined ? null : obj_anexo_3?.a_dois_camp7.toString(),
                        a_dois_camp8: obj_anexo_3?.a_dois_camp8 === undefined ? null : obj_anexo_3?.a_dois_camp8.toString(),

                        a_tres_camp1: obj_anexo_3?.a_tres_camp1 === undefined ? null : obj_anexo_3?.a_tres_camp1.toString(),
                        a_tres_camp2: obj_anexo_3?.a_tres_camp2 === undefined ? null : obj_anexo_3?.a_tres_camp2.toString(),
                        a_tres_camp3: obj_anexo_3?.a_tres_camp3 === undefined ? null : obj_anexo_3?.a_tres_camp3.toString(),
                        a_tres_camp4: obj_anexo_3?.a_tres_camp4 === undefined ? null : obj_anexo_3?.a_tres_camp4.toString(),
                        a_tres_camp5: obj_anexo_3?.a_tres_camp5 === undefined ? null : obj_anexo_3?.a_tres_camp5.toString(),
                        a_tres_camp6: obj_anexo_3?.a_tres_camp6 === undefined ? null : obj_anexo_3?.a_tres_camp6.toString(),
                        a_tres_camp7: obj_anexo_3?.a_tres_camp7 === undefined ? null : obj_anexo_3?.a_tres_camp7.toString(),
                        a_tres_camp8: obj_anexo_3?.a_tres_camp8 === undefined ? null : obj_anexo_3?.a_tres_camp8.toString(),

                        soma_camp1: obj_anexo_3?.soma_camp1 === undefined ? null : obj_anexo_3?.soma_camp1.toString(),
                        soma_camp2: obj_anexo_3?.soma_camp2 === undefined ? null : obj_anexo_3?.soma_camp2.toString(),
                        soma_camp3: obj_anexo_3?.soma_camp3 === undefined ? null : obj_anexo_3?.soma_camp3.toString(),
                        soma_camp4: obj_anexo_3?.soma_camp4 === undefined ? null : obj_anexo_3?.soma_camp4.toString(),
                        soma_camp5: obj_anexo_3?.soma_camp5 === undefined ? null : obj_anexo_3?.soma_camp5.toString(),
                        soma_camp6: obj_anexo_3?.soma_camp6 === undefined ? null : obj_anexo_3?.soma_camp6.toString(),
                        soma_camp7: obj_anexo_3?.soma_camp7 === undefined ? null : obj_anexo_3?.soma_camp7.toString(),
                        soma_camp8: obj_anexo_3?.soma_camp8 === undefined ? null : obj_anexo_3?.soma_camp8.toString(),

                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista_3((old) => [...old, data.data.result])
                    set_obj_anexo_3(undefined)
                    set_flag_editado_3(false)

                    set_flag_criar_anexo_3(false)
                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }
    const handle_criar_anexo_cabecalho = async () => {


        try {
            setIsLoading(true);

            let data = await post(auth.token.cookie_token, "new_reg_anexo_um_plano_ferti", {
                payload: {
                    id_plano_um: 0,
                    fonte_camp1: obj_anexo_cabecalho?.fonte_camp1 === undefined ? null : obj_anexo_cabecalho?.fonte_camp1,
                    fonte_camp2: obj_anexo_cabecalho?.fonte_camp2 === undefined ? null : obj_anexo_cabecalho?.fonte_camp2,
                    fonte_camp3: obj_anexo_cabecalho?.fonte_camp3 === undefined ? null : obj_anexo_cabecalho?.fonte_camp3,
                    id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: ""
                }
            })
            if (data.status === 200) {
                setMessage("Operação efetuada com sucesso!");
                setOpenSnackSuccess(true);
                set_obj_anexo_cabecalho_lista([data.data.result])
                set_obj_anexo_cabecalho(undefined)
                set_flag_criar_cabecalho(false)
                set_flag_editado_cabecalho(false)

            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print('handle_criar_anexo', error, true)
            setIsLoading(false);

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
        }

    }

    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
        set_flag_editado(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo(aux_obj_anexo);

        } else {

            if (name === 'fonte_nutri_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp1(true)
                } else {
                    seterror_fonte_nutri_camp1(false)

                }

                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp2(true)
                } else {
                    seterror_fonte_nutri_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp3(true)
                } else {
                    seterror_fonte_nutri_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp4(true)
                } else {
                    seterror_fonte_nutri_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp5(true)
                } else {
                    seterror_fonte_nutri_camp5(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp6(true)
                } else {
                    seterror_fonte_nutri_camp6(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp7(true)
                } else {
                    seterror_fonte_nutri_camp7(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'fonte_nutri_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    seterror_fonte_nutri_camp8(true)
                } else {
                    seterror_fonte_nutri_camp8(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }


        }


    };


    const onInputChange_3 = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo_3 === undefined ? {} : obj_anexo_3
        set_flag_editado_3(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo_3(aux_obj_anexo);

        } else {

            if (name === 'a_um_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp1(true)
                } else {
                    set_error_a_um_camp1(false)

                    let aux_value1 = format_strings_to_numbers(value)

                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp1 !== undefined && obj_anexo_3.soma_camp1 !== undefined ? obj_anexo_3?.a_um_camp1 : 0

                    let total_soma_1 = obj_anexo_3?.soma_camp1 !== undefined ?
                        obj_anexo_3?.soma_camp1 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp1']: total_soma_1,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp2(true)
                } else {
                    set_error_a_um_camp2(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp2 !== undefined && obj_anexo_3.soma_camp2 !== undefined ? obj_anexo_3?.a_um_camp2 : 0

                    let total_soma_2 = obj_anexo_3?.soma_camp2 !== undefined ?
                        obj_anexo_3?.soma_camp2 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp2']: total_soma_2,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp3(true)
                } else {
                    set_error_a_um_camp3(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp3 !== undefined && obj_anexo_3.soma_camp3 !== undefined ? obj_anexo_3?.a_um_camp3 : 0

                    let total_soma_3 = obj_anexo_3?.soma_camp3 !== undefined ?
                        obj_anexo_3?.soma_camp3 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp3']: total_soma_3,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp4(true)
                } else {
                    set_error_a_um_camp4(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp4 !== undefined && obj_anexo_3.soma_camp4 !== undefined ? obj_anexo_3?.a_um_camp4 : 0

                    let total_soma_4 = obj_anexo_3?.soma_camp4 !== undefined ?
                        obj_anexo_3?.soma_camp4 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp4']: total_soma_4,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp5(true)
                } else {
                    set_error_a_um_camp5(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp5 !== undefined && obj_anexo_3.soma_camp5 !== undefined ? obj_anexo_3?.a_um_camp5 : 0

                    let total_soma_5 = obj_anexo_3?.soma_camp5 !== undefined ?
                        obj_anexo_3?.soma_camp5 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp5']: total_soma_5,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp6(true)
                } else {
                    set_error_a_um_camp6(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp6 !== undefined && obj_anexo_3.soma_camp6 !== undefined ? obj_anexo_3?.a_um_camp6 : 0

                    let total_soma_6 = obj_anexo_3?.soma_camp6 !== undefined ?
                        obj_anexo_3?.soma_camp6 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp6']: total_soma_6,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp7(true)
                } else {
                    set_error_a_um_camp7(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp7 !== undefined && obj_anexo_3.soma_camp7 !== undefined ? obj_anexo_3?.a_um_camp7 : 0

                    let total_soma_7 = obj_anexo_3?.soma_camp7 !== undefined ?
                        obj_anexo_3?.soma_camp7 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp7']: total_soma_7,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_um_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_um_camp8(true)
                } else {
                    set_error_a_um_camp8(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_um_camp8 !== undefined && obj_anexo_3.soma_camp8 !== undefined ? obj_anexo_3?.a_um_camp8 : 0

                    let total_soma_8 = obj_anexo_3?.soma_camp8 !== undefined ?
                        obj_anexo_3?.soma_camp8 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp8']: total_soma_8,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp1(true)
                } else {
                    set_error_a_dois_camp1(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp1 !== undefined && obj_anexo_3.soma_camp1 !== undefined ? obj_anexo_3?.a_dois_camp1 : 0

                    let total_soma_1 = obj_anexo_3?.soma_camp1 !== undefined ?
                        obj_anexo_3?.soma_camp1 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp1']: total_soma_1,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp2(true)
                } else {
                    set_error_a_dois_camp2(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp2 !== undefined && obj_anexo_3.soma_camp2 !== undefined ? obj_anexo_3?.a_dois_camp2 : 0

                    let total_soma_2 = obj_anexo_3?.soma_camp2 !== undefined ?
                        obj_anexo_3?.soma_camp2 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp2']: total_soma_2,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp3(true)
                } else {
                    set_error_a_dois_camp3(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp3 !== undefined && obj_anexo_3.soma_camp3 !== undefined ? obj_anexo_3?.a_dois_camp3 : 0

                    let total_soma_3 = obj_anexo_3?.soma_camp3 !== undefined ?
                        obj_anexo_3?.soma_camp3 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp3']: total_soma_3,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp4(true)
                } else {
                    set_error_a_dois_camp4(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp4 !== undefined && obj_anexo_3.soma_camp4 !== undefined ? obj_anexo_3?.a_dois_camp4 : 0

                    let total_soma_4 = obj_anexo_3?.soma_camp4 !== undefined ?
                        obj_anexo_3?.soma_camp4 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp4']: total_soma_4,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp5(true)
                } else {
                    set_error_a_dois_camp5(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp5 !== undefined && obj_anexo_3.soma_camp5 !== undefined ? obj_anexo_3?.a_dois_camp5 : 0

                    let total_soma_5 = obj_anexo_3?.soma_camp5 !== undefined ?
                        obj_anexo_3?.soma_camp5 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp5']: total_soma_5,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp6(true)
                } else {
                    set_error_a_dois_camp6(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp6 !== undefined && obj_anexo_3.soma_camp6 !== undefined ? obj_anexo_3?.a_dois_camp6 : 0

                    let total_soma_6 = obj_anexo_3?.soma_camp6 !== undefined ?
                        obj_anexo_3?.soma_camp6 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp6']: total_soma_6,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp7(true)
                } else {
                    set_error_a_dois_camp7(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp7 !== undefined && obj_anexo_3.soma_camp7 !== undefined ? obj_anexo_3?.a_dois_camp7 : 0

                    let total_soma_7 = obj_anexo_3?.soma_camp7 !== undefined ?
                        obj_anexo_3?.soma_camp7 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp7']: total_soma_7,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_dois_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_dois_camp8(true)
                } else {
                    set_error_a_dois_camp8(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_dois_camp8 !== undefined && obj_anexo_3.soma_camp8 !== undefined ? obj_anexo_3?.a_dois_camp8 : 0

                    let total_soma_8 = obj_anexo_3?.soma_camp8 !== undefined ?
                        obj_anexo_3?.soma_camp8 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp8']: total_soma_8,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp1(true)
                } else {
                    set_error_a_tres_camp1(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp1 !== undefined && obj_anexo_3.soma_camp1 !== undefined ? obj_anexo_3?.a_tres_camp1 : 0

                    let total_soma_1 = obj_anexo_3?.soma_camp1 !== undefined ?
                        obj_anexo_3?.soma_camp1 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp1']: total_soma_1,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp2(true)
                } else {
                    set_error_a_tres_camp2(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp2 !== undefined && obj_anexo_3.soma_camp2 !== undefined ? obj_anexo_3?.a_tres_camp2 : 0

                    let total_soma_2 = obj_anexo_3?.soma_camp2 !== undefined ?
                        obj_anexo_3?.soma_camp2 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp2']: total_soma_2,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp3(true)
                } else {
                    set_error_a_tres_camp3(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp3 !== undefined && obj_anexo_3.soma_camp3 !== undefined ? obj_anexo_3?.a_tres_camp3 : 0

                    let total_soma_3 = obj_anexo_3?.soma_camp3 !== undefined ?
                        obj_anexo_3?.soma_camp3 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp3']: total_soma_3,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp4(true)
                } else {
                    set_error_a_tres_camp4(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp4 !== undefined && obj_anexo_3.soma_camp4 !== undefined ? obj_anexo_3?.a_tres_camp4 : 0

                    let total_soma_4 = obj_anexo_3?.soma_camp4 !== undefined ?
                        obj_anexo_3?.soma_camp4 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp4']: total_soma_4,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp5(true)
                } else {
                    set_error_a_tres_camp5(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp5 !== undefined && obj_anexo_3.soma_camp5 !== undefined ? obj_anexo_3?.a_tres_camp5 : 0

                    let total_soma_5 = obj_anexo_3?.soma_camp5 !== undefined ?
                        obj_anexo_3?.soma_camp5 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp5']: total_soma_5,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp6(true)
                } else {
                    set_error_a_tres_camp6(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp6 !== undefined && obj_anexo_3.soma_camp6 !== undefined ? obj_anexo_3?.a_tres_camp6 : 0

                    let total_soma_6 = obj_anexo_3?.soma_camp6 !== undefined ?
                        obj_anexo_3?.soma_camp6 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp6']: total_soma_6,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp7(true)
                } else {
                    set_error_a_tres_camp7(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp7 !== undefined && obj_anexo_3.soma_camp7 !== undefined ? obj_anexo_3?.a_tres_camp7 : 0

                    let total_soma_7 = obj_anexo_3?.soma_camp7 !== undefined ?
                        obj_anexo_3?.soma_camp7 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp7']: total_soma_7,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'a_tres_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_a_tres_camp8(true)
                } else {
                    set_error_a_tres_camp8(false)
                    let aux_value1 = format_strings_to_numbers(value)
                    let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
                    let valor_remover = obj_anexo_3?.a_tres_camp8 !== undefined && obj_anexo_3.soma_camp8 !== undefined ? obj_anexo_3?.a_tres_camp8 : 0

                    let total_soma_8 = obj_anexo_3?.soma_camp8 !== undefined ?
                        obj_anexo_3?.soma_camp8 - valor_remover + aux_value
                        :
                        aux_value
                    set_obj_anexo_3((prevManeio: any) => ({
                        ...prevManeio,
                        ['soma_camp8']: total_soma_8,
                    }));
                }
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));

            } else {
                set_obj_anexo_3((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }
        }
    };
    const onInputChange_cabecalho = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo_cabecalho === undefined ? {} : obj_anexo_cabecalho
        set_flag_editado_cabecalho(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo_cabecalho(aux_obj_anexo);

        } else {
            set_obj_anexo_cabecalho((old: any) => ({
                ...old,
                [name]: value,
            }));
        }


    };
    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_plano_ferti_um/${obj_anexo?.id_plano_dois}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.filter((el) => {
                    if (el.id_plano_dois !== obj_anexo?.id_plano_dois) {
                        return el
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    setCreateTable(true)
                }
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };
    const handle_delete_anexo_3 = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_plano_ferti_dois/${obj_anexo_3?.id_plano_tres}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista_3?.filter((el) => {
                    if (el.id_plano_tres !== obj_anexo_3?.id_plano_tres) {
                        return el
                    }
                })
                set_obj_anexo_lista_3(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo_3(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    set_flag_criar_anexo_3(true)
                }
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar_3(false);
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };
    const handle_delete_anexo_cabecalho = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_plano_ferti/${obj_anexo_cabecalho?.id_plano_um}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) => {
                    if (el.id_plano_um !== obj_anexo_cabecalho?.id_plano_um) {
                        return el
                    }
                })
                set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo_cabecalho(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    set_flag_criar_cabecalho(true)
                }
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar_cabecalho(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };
    const handle_update_anexo = async () => {
        if (error_fonte_nutri_camp1 || error_fonte_nutri_camp2 || error_fonte_nutri_camp3 || error_fonte_nutri_camp4 || error_fonte_nutri_camp5 || error_fonte_nutri_camp6 || error_fonte_nutri_camp7 || error_fonte_nutri_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {
            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_plano_ferti_um", { payload: obj_anexo });

                if (res.status === 200) {
                    let lista_aux: any = obj_anexo_lista?.map((el) => {
                        if (el.id_plano_dois !== obj_anexo?.id_plano_dois) {
                            return el
                        } else {
                            return res.data.result
                        }
                    })
                    set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                    set_obj_anexo(undefined);
                    set_flag_editado(false)



                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);


                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    };
    const handle_update_anexo_3 = async () => {
        if (error_a_um_camp1 ||
            error_a_um_camp2 ||
            error_a_um_camp3 ||
            error_a_um_camp4 ||
            error_a_um_camp5 ||
            error_a_um_camp6 ||
            error_a_um_camp7 ||
            error_a_um_camp8 ||


            error_a_dois_camp1 ||
            error_a_dois_camp2 ||
            error_a_dois_camp3 ||
            error_a_dois_camp4 ||
            error_a_dois_camp5 ||
            error_a_dois_camp6 ||
            error_a_dois_camp7 ||
            error_a_dois_camp8 ||

            error_a_tres_camp1 ||
            error_a_tres_camp2 ||
            error_a_tres_camp3 ||
            error_a_tres_camp4 ||
            error_a_tres_camp5 ||
            error_a_tres_camp6 ||
            error_a_tres_camp7 ||
            error_a_tres_camp8

        ) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {
            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_plano_ferti_dois", {
                    payload: {
                        id_plano_tres: obj_anexo_3?.id_plano_tres === undefined || obj_anexo_3?.id_plano_tres === null ? null : obj_anexo_3?.id_plano_tres,
                        a_um_camp1: obj_anexo_3?.a_um_camp1 === undefined || obj_anexo_3?.a_um_camp1 === null ? null : obj_anexo_3?.a_um_camp1.toString(),
                        a_um_camp2: obj_anexo_3?.a_um_camp2 === undefined || obj_anexo_3?.a_um_camp2 === null ? null : obj_anexo_3?.a_um_camp2.toString(),
                        a_um_camp3: obj_anexo_3?.a_um_camp3 === undefined || obj_anexo_3?.a_um_camp3 === null ? null : obj_anexo_3?.a_um_camp3.toString(),
                        a_um_camp4: obj_anexo_3?.a_um_camp4 === undefined || obj_anexo_3?.a_um_camp4 === null ? null : obj_anexo_3?.a_um_camp4.toString(),
                        a_um_camp5: obj_anexo_3?.a_um_camp5 === undefined || obj_anexo_3?.a_um_camp5 === null ? null : obj_anexo_3?.a_um_camp5.toString(),
                        a_um_camp6: obj_anexo_3?.a_um_camp6 === undefined || obj_anexo_3?.a_um_camp6 === null ? null : obj_anexo_3?.a_um_camp6.toString(),
                        a_um_camp7: obj_anexo_3?.a_um_camp7 === undefined || obj_anexo_3?.a_um_camp7 === null ? null : obj_anexo_3?.a_um_camp7.toString(),
                        a_um_camp8: obj_anexo_3?.a_um_camp8 === undefined || obj_anexo_3?.a_um_camp8 === null ? null : obj_anexo_3?.a_um_camp8.toString(),

                        a_dois_camp1: obj_anexo_3?.a_dois_camp1 === undefined || obj_anexo_3?.a_dois_camp1 === null ? null : obj_anexo_3?.a_dois_camp1.toString(),
                        a_dois_camp2: obj_anexo_3?.a_dois_camp2 === undefined || obj_anexo_3?.a_dois_camp2 === null ? null : obj_anexo_3?.a_dois_camp2.toString(),
                        a_dois_camp3: obj_anexo_3?.a_dois_camp3 === undefined || obj_anexo_3?.a_dois_camp3 === null ? null : obj_anexo_3?.a_dois_camp3.toString(),
                        a_dois_camp4: obj_anexo_3?.a_dois_camp4 === undefined || obj_anexo_3?.a_dois_camp4 === null ? null : obj_anexo_3?.a_dois_camp4.toString(),
                        a_dois_camp5: obj_anexo_3?.a_dois_camp5 === undefined || obj_anexo_3?.a_dois_camp5 === null ? null : obj_anexo_3?.a_dois_camp5.toString(),
                        a_dois_camp6: obj_anexo_3?.a_dois_camp6 === undefined || obj_anexo_3?.a_dois_camp6 === null ? null : obj_anexo_3?.a_dois_camp6.toString(),
                        a_dois_camp7: obj_anexo_3?.a_dois_camp7 === undefined || obj_anexo_3?.a_dois_camp7 === null ? null : obj_anexo_3?.a_dois_camp7.toString(),
                        a_dois_camp8: obj_anexo_3?.a_dois_camp8 === undefined || obj_anexo_3?.a_dois_camp8 === null ? null : obj_anexo_3?.a_dois_camp8.toString(),

                        a_tres_camp1: obj_anexo_3?.a_tres_camp1 === undefined || obj_anexo_3?.a_tres_camp1 === null ? null : obj_anexo_3?.a_tres_camp1.toString(),
                        a_tres_camp2: obj_anexo_3?.a_tres_camp2 === undefined || obj_anexo_3?.a_tres_camp2 === null ? null : obj_anexo_3?.a_tres_camp2.toString(),
                        a_tres_camp3: obj_anexo_3?.a_tres_camp3 === undefined || obj_anexo_3?.a_tres_camp3 === null ? null : obj_anexo_3?.a_tres_camp3.toString(),
                        a_tres_camp4: obj_anexo_3?.a_tres_camp4 === undefined || obj_anexo_3?.a_tres_camp4 === null ? null : obj_anexo_3?.a_tres_camp4.toString(),
                        a_tres_camp5: obj_anexo_3?.a_tres_camp5 === undefined || obj_anexo_3?.a_tres_camp5 === null ? null : obj_anexo_3?.a_tres_camp5.toString(),
                        a_tres_camp6: obj_anexo_3?.a_tres_camp6 === undefined || obj_anexo_3?.a_tres_camp6 === null ? null : obj_anexo_3?.a_tres_camp6.toString(),
                        a_tres_camp7: obj_anexo_3?.a_tres_camp7 === undefined || obj_anexo_3?.a_tres_camp7 === null ? null : obj_anexo_3?.a_tres_camp7.toString(),
                        a_tres_camp8: obj_anexo_3?.a_tres_camp8 === undefined || obj_anexo_3?.a_tres_camp8 === null ? null : obj_anexo_3?.a_tres_camp8.toString(),

                        soma_camp1: obj_anexo_3?.soma_camp1 === undefined || obj_anexo_3?.soma_camp1 === null ? null : obj_anexo_3?.soma_camp1.toString(),
                        soma_camp2: obj_anexo_3?.soma_camp2 === undefined || obj_anexo_3?.soma_camp2 === null ? null : obj_anexo_3?.soma_camp2.toString(),
                        soma_camp3: obj_anexo_3?.soma_camp3 === undefined || obj_anexo_3?.soma_camp3 === null ? null : obj_anexo_3?.soma_camp3.toString(),
                        soma_camp4: obj_anexo_3?.soma_camp4 === undefined || obj_anexo_3?.soma_camp4 === null ? null : obj_anexo_3?.soma_camp4.toString(),
                        soma_camp5: obj_anexo_3?.soma_camp5 === undefined || obj_anexo_3?.soma_camp5 === null ? null : obj_anexo_3?.soma_camp5.toString(),
                        soma_camp6: obj_anexo_3?.soma_camp6 === undefined || obj_anexo_3?.soma_camp6 === null ? null : obj_anexo_3?.soma_camp6.toString(),
                        soma_camp7: obj_anexo_3?.soma_camp7 === undefined || obj_anexo_3?.soma_camp7 === null ? null : obj_anexo_3?.soma_camp7.toString(),
                        soma_camp8: obj_anexo_3?.soma_camp8 === undefined || obj_anexo_3?.soma_camp8 === null ? null : obj_anexo_3?.soma_camp8.toString(),

                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""

                    }
                });

                if (res.status === 200) {
                    let lista_aux: any = obj_anexo_lista_3?.map((el) => {
                        if (el.id_plano_tres !== obj_anexo_3?.id_plano_tres) {
                            return el
                        } else {
                            return res.data.result
                        }
                    })
                    set_obj_anexo_lista_3(lista_aux === undefined ? [] : lista_aux)
                    set_obj_anexo_3(undefined);
                    set_flag_editado_3(false)

                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);


                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    };
    const handle_update_anexo_cabecalho = async () => {
        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, "update_reg_anexo_um_plano_ferti", { payload: obj_anexo_cabecalho });

            if (res.status === 200) {
                let lista_aux: any = obj_anexo_cabecalho_lista?.map((el) => {
                    if (el.id_plano_um !== obj_anexo_cabecalho?.id_plano_um) {
                        return el
                    } else {
                        return res.data.result
                    }
                })
                set_flag_editado_cabecalho(false)

                set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo_cabecalho(undefined);
                set_flag_criar_cabecalho(false)
                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("handle_update_anexo", error, true);
            setMessage("Erro ao gravar!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };



    const get_info = async () => {
        try {
            let res_cabecalho = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_plano_ferti_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );
            let res_linhas = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_plano_ferti_um_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );
            let res_linhas_3 = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_plano_ferti_dois_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );
            if (res_cabecalho.status === 200) {
                if (res_cabecalho.data.result.length !== 0) {
                    set_obj_anexo_cabecalho_lista(res_cabecalho.data.result);

                } else {
                    set_flag_criar_cabecalho(true)
                }
                if (res_linhas.status === 200) {
                    if (res_linhas.data.result.length !== 0) {
                        set_obj_anexo_lista(res_linhas.data.result);
                    } else {
                        setCreateTable(true)
                    }
                    if (res_linhas_3.status === 200) {
                        if (res_linhas_3.data.result.length !== 0) {
                            set_obj_anexo_lista_3(res_linhas_3.data.result);
                        } else {
                            set_flag_criar_anexo_3(true)
                        }
                    } else {
                        setMessage("Erro a carregar informação!");
                        setOpenSnackError(true);
                    }
                } else {
                    setMessage("Erro a carregar informação!");
                    setOpenSnackError(true);
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();
                set_existe_cabecalho(true)

            } else {
                setCreateTable(false)
                set_flag_criar_cabecalho(false)
                set_existe_cabecalho(false)
                set_obj_anexo_cabecalho_lista([])
                set_obj_anexo_lista([])
                set_obj_anexo_lista_3([])
            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    const handleCloseDialog = () => {
        setCreateTable(false)
        set_obj_anexo(undefined)

        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };


    const handleCloseDialog_cabecalho = () => {
        set_flag_criar_cabecalho(false)
        set_obj_anexo_cabecalho(undefined)
        set_flag_editado_cabecalho(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_cabecalho(false)
    };
    const handleCloseDialog_3 = () => {
        set_obj_anexo_3(undefined)

        set_flag_editado_3(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_3(false)
    };

    const handleCloseSnack = () => {

        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };

    return (
        <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
                height: "auto",
                width: "auto",
                margin: 2,
                padding: 2,
            }}
        >
            <Snackbar
                open={openSnackSuccess}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
            >
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openSnackError}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
            >
                <Alert
                    onClose={handleCloseSnack}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {message}

                </Alert>
            </Snackbar>

            <TableRow>
                <TableCell
                    colSpan={8}
                    sx={{
                        fontWeight: 600,
                        fontSize: 18,
                        textAlign: "left",
                        fontFamily: "candara",
                    }}
                >
                    4 - Plano de aplicação de fertilizantes
                </TableCell>
                <TableCell>
                    {/* {
                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined || obj_anexo_lista.length === 0 || obj_anexo_lista === undefined ?
                            <></>
                            : */}
                    {/* <Stack direction="row" justifyContent="end">
                        {

                            existe_cabecalho === false ? <></> :
                                <BarraDeFerramentas
                                    mostrarBotaoNovo
                                    textoBotaoNovo="Registar"
                                    aoClicarNovo={() => {
                                        set_obj_anexo_cabecalho(undefined)
                                        set_obj_anexo_3(undefined)
                                        setCreateTable(false)
                                        set_flag_criar_anexo_3(false)
                                        setCreateTable(true)
                                    }}
                                />
                        }
                    </Stack> */}

                    {/* } */}

                </TableCell>

            </TableRow>
            <TableRow>
                <TableCell colSpan={2}></TableCell>
                <StyledTableHead colSpan={8}>
                    Nutrientes disponibilizados por tipo de fertilizantes
                </StyledTableHead>
            </TableRow>

            <StyledTableCell>
                Fonte de Nutrientes
                <BasicPopover
                    text={
                        "Nas linhas seguintes o beneficiário deverá identificar o tipo de fertilizante que prevê utilizar para suprir as necessidade determinadas no campo «Previsão total de nutrientes a disponibilizar à cultura» e a respetiva quantificação dos nutrientes.\n\nValores possíveis:\n- Aplicação de corretivos minerais;\n- Aplicação de estrume;\n- Aplicação de chorume;\n- Aplicação de digerido de Unidade de Biogás;\n- Aplicação de sedimentos depositados nos orgãos de armazenamento de efluentes pecuários;\n- Mistura de efluentes pecuários e seus derivados;\n- Aplicação de Composto de bioresíduos de origem agrícola;\n- Aplicação de Composto orgânico de Unidade de tratamento de residuos sólidos urbanos;\n- Aplicação de outro tipo de composto;\n- Fertilizante de síntese.\n\nPara os fertilizantes de síntese deverão ser registadas tantas linhas quantas as diferentes formulações o beneficiário pretender aplicar."
                    }
                />
            </StyledTableCell>
            <StyledTableCell>
                Quantidade de fertilizante (kg/ha)
            </StyledTableCell>
            <StyledTableCell>N (kg/ha)</StyledTableCell>
            <StyledTableCell>P2O5 (kg/ha)</StyledTableCell>
            <StyledTableCell>K2O (kg/ha)</StyledTableCell>
            <StyledTableCell>Mg (kg/ha)</StyledTableCell>
            <StyledTableCellRight>

                {
                    flag_criar_cabecalho === false ?
                        <>
                            <BasicPopover
                                text={
                                    "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                }
                            />
                            {obj_anexo_cabecalho_lista.length === 0 ? '' : obj_anexo_cabecalho_lista[0].fonte_camp1 === undefined ? '' : obj_anexo_cabecalho_lista[0].fonte_camp1}
                        </>

                        :
                        <CustomTextField
                            name="fonte_camp1"
                            value={obj_anexo_cabecalho?.fonte_camp1 === undefined ? '' : obj_anexo_cabecalho?.fonte_camp1}
                            onChange={onInputChange_cabecalho}
                        />
                }

            </StyledTableCellRight>
            <StyledTableCellRight>
                {
                    flag_criar_cabecalho === false ?
                        <>

                            <BasicPopover
                                text={
                                    "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                }
                            />
                            {obj_anexo_cabecalho_lista.length === 0 ? '' : obj_anexo_cabecalho_lista[0].fonte_camp2}
                        </>


                        :
                        <CustomTextField
                            name="fonte_camp2"
                            value={obj_anexo_cabecalho?.fonte_camp2 === undefined ? '' : obj_anexo_cabecalho?.fonte_camp2}
                            onChange={onInputChange_cabecalho}
                        />
                }
            </StyledTableCellRight>
            <StyledTableCellRight>
                {
                    flag_criar_cabecalho === false ?
                        <>

                            <BasicPopover
                                text={
                                    "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                }
                            />
                            {obj_anexo_cabecalho_lista.length === 0 ? '' : obj_anexo_cabecalho_lista[0].fonte_camp3}
                        </>

                        :
                        <CustomTextField
                            name="fonte_camp3"
                            value={obj_anexo_cabecalho?.fonte_camp3 === undefined ? '' : obj_anexo_cabecalho?.fonte_camp3}
                            onChange={onInputChange_cabecalho}
                        />
                }
            </StyledTableCellRight>
            {
                flag_criar_cabecalho === false ?
                    <StyledTableCell>
                        {

                            existe_cabecalho === false ? <></> :
                                is_historico === true ? <></> :

                                    <ButtonCadernos
                                        mostrarBotaoEditar
                                        aoClicarEditar={() => {
                                            set_flag_criar_cabecalho(true)
                                            set_obj_anexo_cabecalho(obj_anexo_cabecalho_lista[0])



                                        }}
                                        mostrarBotaoApagar
                                        aoClicarApagar={() => {
                                            set_obj_anexo_cabecalho(obj_anexo_cabecalho_lista[0])
                                            set_open_dialog_tem_a_certeza_que_quer_eliminar_cabecalho(true)
                                        }}
                                    />
                        }
                    </StyledTableCell>
                    :
                    obj_anexo_cabecalho_lista.length === 0 ?

                        <StyledTableCell>
                            {is_historico === true ? <></> :

                                <ButtonCadernos
                                    mostrarBotaoGravar
                                    aoClicarGravar={() => {
                                        handle_criar_anexo_cabecalho()

                                    }}
                                />}
                        </StyledTableCell>

                        :
                        <StyledTableCell>
                            <ButtonCadernos
                                mostrarBotaoGravar
                                aoClicarGravar={() => {
                                    handle_update_anexo_cabecalho()

                                }}
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                    if (flag_editado_cabecalho) {
                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_cabecalho(true)
                                    } else {
                                        set_flag_criar_cabecalho(false)
                                        set_obj_anexo_cabecalho(undefined)
                                    }

                                }}
                            />
                        </StyledTableCell>
            }


            {createTable && obj_anexo_cabecalho_lista.length !== 0 && (

                <TableRow>
                    <StyledTableCell>
                        <CustomSelect
                            value={obj_anexo?.fonte_nutri === undefined ? '' : obj_anexo?.fonte_nutri}
                            name="fonte_nutri"
                            onChange={onInputChange}
                            options={nutriente}
                            label="Espécie Pecuária"
                        />
                    </StyledTableCell>
                    <StyledTableCell>
                        <CustomTextField
                            name="fonte_nutri_camp1"
                            value={obj_anexo?.fonte_nutri_camp1 === undefined ? '' : obj_anexo?.fonte_nutri_camp1.toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={error_fonte_nutri_camp1}
                            helperText={error_fonte_nutri_camp1 ? "Apenas números são aceites" : ""}
                        />
                    </StyledTableCell>
                    <StyledTableCell>
                        <CustomTextField
                            name="fonte_nutri_camp2"
                            value={obj_anexo?.fonte_nutri_camp2 === undefined ? '' : obj_anexo?.fonte_nutri_camp2.toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={error_fonte_nutri_camp2}
                            helperText={error_fonte_nutri_camp2 ? "Apenas números são aceites" : ""}
                        />
                    </StyledTableCell>
                    <StyledTableCell>
                        <CustomTextField
                            name="fonte_nutri_camp3"
                            value={obj_anexo?.fonte_nutri_camp3 === undefined ? '' : obj_anexo?.fonte_nutri_camp3.toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={error_fonte_nutri_camp3}
                            helperText={error_fonte_nutri_camp3 ? "Apenas números são aceites" : ""}
                        />
                    </StyledTableCell>
                    <StyledTableCell>
                        <CustomTextField
                            name="fonte_nutri_camp4"
                            value={obj_anexo?.fonte_nutri_camp4 === undefined ? '' : obj_anexo?.fonte_nutri_camp4.toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={error_fonte_nutri_camp4}
                            helperText={error_fonte_nutri_camp4 ? "Apenas números são aceites" : ""}
                        />
                    </StyledTableCell>
                    <StyledTableCell>
                        <CustomTextField
                            name="fonte_nutri_camp5"
                            value={obj_anexo?.fonte_nutri_camp5 === undefined ? '' : obj_anexo?.fonte_nutri_camp5.toString().replace('.', ',')}
                            onChange={onInputChange}
                            error={error_fonte_nutri_camp5}
                            helperText={error_fonte_nutri_camp5 ? "Apenas números são aceites" : ""}
                        />
                    </StyledTableCell>
                    <StyledTableCell>
                        {
                            obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                <></>
                                :
                                <CustomTextField
                                    name="fonte_nutri_camp6"
                                    value={obj_anexo?.fonte_nutri_camp6 === undefined ? '' : obj_anexo?.fonte_nutri_camp6.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp6}
                                    helperText={error_fonte_nutri_camp6 ? "Apenas números são aceites" : ""}
                                />
                        }

                    </StyledTableCell>
                    <StyledTableCell>
                        {
                            obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                <></>
                                :
                                <CustomTextField
                                    name="fonte_nutri_camp7"
                                    value={obj_anexo?.fonte_nutri_camp7 === undefined ? '' : obj_anexo?.fonte_nutri_camp7.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp7}
                                    helperText={error_fonte_nutri_camp7 ? "Apenas números são aceites" : ""}
                                />
                        }

                    </StyledTableCell>
                    <StyledTableCell>
                        {
                            obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                <></>
                                :
                                <CustomTextField
                                    name="fonte_nutri_camp8"
                                    value={obj_anexo?.fonte_nutri_camp8 === undefined ? '' : obj_anexo?.fonte_nutri_camp8.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp8}
                                    helperText={error_fonte_nutri_camp8 ? "Apenas números são aceites" : ""}
                                />
                        }

                    </StyledTableCell>

                    <StyledTableCell>
                        <Stack direction="row" justifyContent="center">
                            {
                                obj_anexo_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                    is_historico === true ? <></> :

                                        <ButtonCadernos
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => { handle_criar_anexo() }}
                                        />
                                    : <ButtonCadernos
                                        mostrarBotaoCancelar
                                        aoClicarCancelar={() => {
                                            if (flag_editado) {
                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                            } else {
                                                setCreateTable(false)
                                            }

                                        }}
                                        mostrarBotaoGravar
                                        aoClicarGravar={() => { handle_criar_anexo() }}
                                    />
                            }

                        </Stack>
                    </StyledTableCell>
                </TableRow>

            )}
            {obj_anexo_lista?.map((row) => {
                if (row.id_plano_dois === obj_anexo?.id_plano_dois) {
                    return (
                        <TableRow>
                            <StyledTableCell>
                                <CustomSelect
                                    value={obj_anexo?.fonte_nutri === undefined ? '' : obj_anexo?.fonte_nutri}
                                    name="fonte_nutri"
                                    onChange={onInputChange}
                                    options={nutriente}
                                    label="Espécie Pecuária"
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="fonte_nutri_camp1"
                                    value={obj_anexo?.fonte_nutri_camp1 === null ? '' : obj_anexo?.fonte_nutri_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp1}
                                    helperText={error_fonte_nutri_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="fonte_nutri_camp2"
                                    value={obj_anexo?.fonte_nutri_camp2 === null ? '' : obj_anexo?.fonte_nutri_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp2}
                                    helperText={error_fonte_nutri_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="fonte_nutri_camp3"
                                    value={obj_anexo?.fonte_nutri_camp3 === null ? '' : obj_anexo?.fonte_nutri_camp3.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp3}
                                    helperText={error_fonte_nutri_camp3 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="fonte_nutri_camp4"
                                    value={obj_anexo?.fonte_nutri_camp4 === null ? '' : obj_anexo?.fonte_nutri_camp4.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp4}
                                    helperText={error_fonte_nutri_camp4 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="fonte_nutri_camp5"
                                    value={obj_anexo?.fonte_nutri_camp5 === null ? '' : obj_anexo?.fonte_nutri_camp5.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_fonte_nutri_camp5}
                                    helperText={error_fonte_nutri_camp5 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="fonte_nutri_camp6"
                                            value={obj_anexo?.fonte_nutri_camp6 === null ? '' : obj_anexo?.fonte_nutri_camp6.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_fonte_nutri_camp6}
                                            helperText={error_fonte_nutri_camp6 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="fonte_nutri_camp7"
                                            value={obj_anexo?.fonte_nutri_camp7 === null ? '' : obj_anexo?.fonte_nutri_camp7.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_fonte_nutri_camp7}
                                            helperText={error_fonte_nutri_camp7 ? "Apenas números são aceites" : ""}
                                        />
                                }

                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="fonte_nutri_camp8"
                                            value={obj_anexo?.fonte_nutri_camp8 === null ? '' : obj_anexo?.fonte_nutri_camp8.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_fonte_nutri_camp8}
                                            helperText={error_fonte_nutri_camp8 ? "Apenas números são aceites" : ""}
                                        />
                                }

                            </StyledTableCell>
                            <StyledTableCell>
                                <ButtonCadernos
                                    mostrarBotaoGravar
                                    aoClicarGravar={() => { handle_update_anexo() }}
                                    mostrarBotaoCancelar
                                    aoClicarCancelar={() => {
                                        if (flag_editado) {
                                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                        } else {


                                            set_obj_anexo(undefined)
                                        }
                                    }}
                                />
                            </StyledTableCell>
                        </TableRow>


                    )
                } else {
                    return (

                        <TableRow>
                            <StyledTableCell>{row.fonte_nutri} </StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp1 === null ? '0,00' : row.fonte_nutri_camp1.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp2 === null ? '0,00' : row.fonte_nutri_camp2.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp3 === null ? '0,00' : row.fonte_nutri_camp3.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp4 === null ? '0,00' : row.fonte_nutri_camp4.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp5 === null ? '0,00' : row.fonte_nutri_camp5.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp6 === null ? '0,00' : row.fonte_nutri_camp6.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp7 === null ? '0,00' : row.fonte_nutri_camp7.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>{row.fonte_nutri_camp8 === null ? '0,00' : row.fonte_nutri_camp8.toString().replace('.', ',')}</StyledTableCell>
                            <StyledTableCell>
                                {is_historico === true ? <></> :

                                    <ButtonCadernos
                                        mostrarBotaoEditar
                                        aoClicarEditar={() => {

                                            set_obj_anexo(row)

                                        }}
                                        mostrarBotaoApagar
                                        aoClicarApagar={() => {
                                            set_obj_anexo(row)
                                            set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                        }}
                                    />}
                            </StyledTableCell>
                        </TableRow>

                    )
                }
            })}

            {
                flag_criar_anexo_3 !== true || obj_anexo_lista.length === 0 || obj_anexo_lista === undefined ?

                    <></>
                    :
                    <>
                        <TableRow>
                            <StyledTableCell
                                sx={{
                                    textAlign: "left",
                                }}
                            >
                                A1 - Total de ferilizantes Orgânicos (só efluentes
                                pecuários e seus equiparados) (kg)
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_um_camp1"

                                    value={obj_anexo_3?.a_um_camp1 === undefined ? '' : obj_anexo_3?.a_um_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_um_camp1}
                                    helperText={error_a_um_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_um_camp2"
                                    value={obj_anexo_3?.a_um_camp2 === undefined ? '' : obj_anexo_3?.a_um_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_um_camp2}
                                    helperText={error_a_um_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_um_camp3"
                                    value={obj_anexo_3?.a_um_camp3 === undefined ? '' : obj_anexo_3?.a_um_camp3.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_um_camp3}
                                    helperText={error_a_um_camp3 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_um_camp4"
                                    value={obj_anexo_3?.a_um_camp4 === undefined ? '' : obj_anexo_3?.a_um_camp4.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_um_camp4}
                                    helperText={error_a_um_camp4 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_um_camp5"
                                    value={obj_anexo_3?.a_um_camp5 === undefined ? '' : obj_anexo_3?.a_um_camp5.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_um_camp5}
                                    helperText={error_a_um_camp5 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_um_camp6"
                                            value={obj_anexo_3?.a_um_camp6 === undefined ? '' : obj_anexo_3?.a_um_camp6.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_um_camp6}
                                            helperText={error_a_um_camp6 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_um_camp7"
                                            value={obj_anexo_3?.a_um_camp7 === undefined ? '' : obj_anexo_3?.a_um_camp7.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_um_camp7}
                                            helperText={error_a_um_camp7 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_um_camp8"
                                            value={obj_anexo_3?.a_um_camp8 === undefined ? '' : obj_anexo_3?.a_um_camp8.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_um_camp8}
                                            helperText={error_a_um_camp8 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell rowSpan={4}>
                                {is_historico === true ? <></> :

                                    <ButtonCadernos
                                        mostrarBotaoGravar
                                        aoClicarGravar={() => { handle_criar_anexo_3() }}

                                    />}
                            </StyledTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledTableCell
                                sx={{
                                    textAlign: "left",
                                }}
                            >
                                A2 - Total de outros fertilizantes orgânicos não
                                contabilizados em A1 (kg)
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_dois_camp1"
                                    value={obj_anexo_3?.a_dois_camp1 === undefined ? '' : obj_anexo_3?.a_dois_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_dois_camp1}
                                    helperText={error_a_dois_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_dois_camp2"
                                    value={obj_anexo_3?.a_dois_camp2 === undefined ? '' : obj_anexo_3?.a_dois_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_dois_camp2}
                                    helperText={error_a_dois_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_dois_camp3"
                                    value={obj_anexo_3?.a_dois_camp3 === undefined ? '' : obj_anexo_3?.a_dois_camp3.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_dois_camp3}
                                    helperText={error_a_dois_camp3 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_dois_camp4"
                                    value={obj_anexo_3?.a_dois_camp4 === undefined ? '' : obj_anexo_3?.a_dois_camp4.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_dois_camp4}
                                    helperText={error_a_dois_camp4 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_dois_camp5"
                                    value={obj_anexo_3?.a_dois_camp5 === undefined ? '' : obj_anexo_3?.a_dois_camp5.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_dois_camp5}
                                    helperText={error_a_dois_camp5 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_dois_camp6"
                                            value={obj_anexo_3?.a_dois_camp6 === undefined ? '' : obj_anexo_3?.a_dois_camp6.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_dois_camp6}
                                            helperText={error_a_dois_camp6 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_dois_camp7"
                                            value={obj_anexo_3?.a_dois_camp7 === undefined ? '' : obj_anexo_3?.a_dois_camp7.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_dois_camp7}
                                            helperText={error_a_dois_camp7 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_dois_camp8"
                                            value={obj_anexo_3?.a_dois_camp8 === undefined ? '' : obj_anexo_3?.a_dois_camp8.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_dois_camp8}
                                            helperText={error_a_dois_camp8 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledTableCell
                                sx={{
                                    textAlign: "left",
                                }}
                            >
                                A3 - Total de fertilizantes não orgânicos (kg)
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_tres_camp1"
                                    value={obj_anexo_3?.a_tres_camp1 === undefined ? '' : obj_anexo_3?.a_tres_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_tres_camp1}
                                    helperText={error_a_tres_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_tres_camp2"
                                    value={obj_anexo_3?.a_tres_camp2 === undefined ? '' : obj_anexo_3?.a_tres_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_tres_camp2}
                                    helperText={error_a_tres_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_tres_camp3"
                                    value={obj_anexo_3?.a_tres_camp3 === undefined ? '' : obj_anexo_3?.a_tres_camp3.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_tres_camp3}
                                    helperText={error_a_tres_camp3 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_tres_camp4"
                                    value={obj_anexo_3?.a_tres_camp4 === undefined ? '' : obj_anexo_3?.a_tres_camp4.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_tres_camp4}
                                    helperText={error_a_tres_camp4 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="a_tres_camp5"
                                    value={obj_anexo_3?.a_tres_camp5 === undefined ? '' : obj_anexo_3?.a_tres_camp5.toString().replace('.', ',')}
                                    onChange={onInputChange_3}
                                    error={error_a_tres_camp5}
                                    helperText={error_a_tres_camp5 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_tres_camp6"
                                            value={obj_anexo_3?.a_tres_camp6 === undefined ? '' : obj_anexo_3?.a_tres_camp6.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_tres_camp6}
                                            helperText={error_a_tres_camp6 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_tres_camp7"
                                            value={obj_anexo_3?.a_tres_camp7 === undefined ? '' : obj_anexo_3?.a_tres_camp7.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_tres_camp7}
                                            helperText={error_a_tres_camp7 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                            <StyledTableCell>
                                {
                                    obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                        <></>
                                        :
                                        <CustomTextField
                                            name="a_tres_camp8"
                                            value={obj_anexo_3?.a_tres_camp8 === undefined ? '' : obj_anexo_3?.a_tres_camp8.toString().replace('.', ',')}
                                            onChange={onInputChange_3}
                                            error={error_a_tres_camp8}
                                            helperText={error_a_tres_camp8 ? "Apenas números são aceites" : ""}
                                        />
                                }
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableCell>A1+A2+A3</StyledTableCell>
                            <StyledTableCell>

                                {obj_anexo_3?.soma_camp1 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp1)}
                            </StyledTableCell>
                            <StyledTableCell>
                                {obj_anexo_3?.soma_camp2 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp2)}

                            </StyledTableCell>
                            <StyledTableCell>

                                {obj_anexo_3?.soma_camp3 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp3)}

                            </StyledTableCell>
                            <StyledTableCell>
                                {obj_anexo_3?.soma_camp4 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp4)}

                            </StyledTableCell>
                            <StyledTableCell>
                                {obj_anexo_3?.soma_camp5 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp5)}

                            </StyledTableCell>
                            <StyledTableCell>
                                {obj_anexo_3?.soma_camp6 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp6)}

                            </StyledTableCell>
                            <StyledTableCell>
                                {obj_anexo_3?.soma_camp7 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp7)}

                            </StyledTableCell>
                            <StyledTableCell>
                                {obj_anexo_3?.soma_camp8 === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_anexo_3?.soma_camp8)}

                            </StyledTableCell>
                        </TableRow>
                    </>
            }


            {obj_anexo_lista_3?.map((row) => {
                if (row.id_plano_tres === obj_anexo_3?.id_plano_tres) {
                    return (

                        <>
                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        textAlign: "left",
                                    }}
                                >
                                    A1 - Total de ferilizantes Orgânicos (só efluentes
                                    pecuários e seus equiparados) (kg)
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_um_camp1"
                                        value={obj_anexo_3?.a_um_camp1 === null ? '' : obj_anexo_3?.a_um_camp1.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_um_camp1}
                                        helperText={error_a_um_camp1 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_um_camp2"
                                        value={obj_anexo_3?.a_um_camp2 === null ? '' : obj_anexo_3?.a_um_camp2.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_um_camp2}
                                        helperText={error_a_um_camp2 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_um_camp3"
                                        value={obj_anexo_3?.a_um_camp3 === null ? '' : obj_anexo_3?.a_um_camp3.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_um_camp3}
                                        helperText={error_a_um_camp3 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_um_camp4"
                                        value={obj_anexo_3?.a_um_camp4 === null ? '' : obj_anexo_3?.a_um_camp4.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_um_camp4}
                                        helperText={error_a_um_camp4 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_um_camp5"
                                        value={obj_anexo_3?.a_um_camp5 === null ? '' : obj_anexo_3?.a_um_camp5.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_um_camp5}
                                        helperText={error_a_um_camp5 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_um_camp6"
                                                value={obj_anexo_3?.a_um_camp6 === null ? '' : obj_anexo_3?.a_um_camp6.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_um_camp6}
                                                helperText={error_a_um_camp6 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_um_camp7"
                                                value={obj_anexo_3?.a_um_camp7 === null ? '' : obj_anexo_3?.a_um_camp7.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_um_camp7}
                                                helperText={error_a_um_camp7 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_um_camp8"
                                                value={obj_anexo_3?.a_um_camp8 === null ? '' : obj_anexo_3?.a_um_camp8.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_um_camp8}
                                                helperText={error_a_um_camp8 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell rowSpan={4}>
                                    {is_historico === true ? <></> :

                                        <ButtonCadernos
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => {

                                                handle_update_anexo_3()
                                            }}
                                            mostrarBotaoCancelar
                                            aoClicarCancelar={() => {

                                                if (flag_editado_3) {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_3(true)
                                                } else {


                                                    set_obj_anexo_3(undefined)
                                                }

                                            }}
                                        />}
                                </StyledTableCell>
                            </TableRow>

                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        textAlign: "left",
                                    }}
                                >
                                    A2 - Total de outros fertilizantes orgânicos não
                                    contabilizados em A1 (kg)
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_dois_camp1"
                                        value={obj_anexo_3?.a_dois_camp1 === null ? '' : obj_anexo_3?.a_dois_camp1.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_dois_camp1}
                                        helperText={error_a_dois_camp1 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_dois_camp2"
                                        value={obj_anexo_3?.a_dois_camp2 === null ? '' : obj_anexo_3?.a_dois_camp2.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_dois_camp2}
                                        helperText={error_a_dois_camp2 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_dois_camp3"
                                        value={obj_anexo_3?.a_dois_camp3 === null ? '' : obj_anexo_3?.a_dois_camp3.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_dois_camp3}
                                        helperText={error_a_dois_camp3 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_dois_camp4"
                                        value={obj_anexo_3?.a_dois_camp4 === null ? '' : obj_anexo_3?.a_dois_camp4.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_dois_camp4}
                                        helperText={error_a_dois_camp4 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_dois_camp5"
                                        value={obj_anexo_3?.a_dois_camp5 === null ? '' : obj_anexo_3?.a_dois_camp5.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_dois_camp5}
                                        helperText={error_a_dois_camp5 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_dois_camp6"
                                                value={obj_anexo_3?.a_dois_camp6 === null ? '' : obj_anexo_3?.a_dois_camp6.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_dois_camp6}
                                                helperText={error_a_dois_camp6 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_dois_camp7"
                                                value={obj_anexo_3?.a_dois_camp7 === null ? '' : obj_anexo_3?.a_dois_camp7.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_dois_camp7}
                                                helperText={error_a_dois_camp7 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_dois_camp8"
                                                value={obj_anexo_3?.a_dois_camp8 === null ? '' : obj_anexo_3?.a_dois_camp8.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_dois_camp8}
                                                helperText={error_a_dois_camp8 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                            </TableRow>

                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        textAlign: "left",
                                    }}
                                >
                                    A3 - Total de fertilizantes não orgânicos (kg)
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_tres_camp1"
                                        value={obj_anexo_3?.a_tres_camp1 === null ? '' : obj_anexo_3?.a_tres_camp1.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_tres_camp1}
                                        helperText={error_a_tres_camp1 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_tres_camp2"
                                        value={obj_anexo_3?.a_tres_camp2 === null ? '' : obj_anexo_3?.a_tres_camp2.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_tres_camp2}
                                        helperText={error_a_tres_camp2 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_tres_camp3"
                                        value={obj_anexo_3?.a_tres_camp3 === null ? '' : obj_anexo_3?.a_tres_camp3.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_tres_camp3}
                                        helperText={error_a_tres_camp3 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_tres_camp4"
                                        value={obj_anexo_3?.a_tres_camp4 === null ? '' : obj_anexo_3?.a_tres_camp4.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_tres_camp4}
                                        helperText={error_a_tres_camp4 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="a_tres_camp5"
                                        value={obj_anexo_3?.a_tres_camp5 === null ? '' : obj_anexo_3?.a_tres_camp5.toString().replace('.', ',')}
                                        onChange={onInputChange_3}
                                        error={error_a_tres_camp5}
                                        helperText={error_a_tres_camp5 ? "Apenas números são aceites" : ""}

                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_tres_camp6"
                                                value={obj_anexo_3?.a_tres_camp6 === null ? '' : obj_anexo_3?.a_tres_camp6.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_tres_camp6}
                                                helperText={error_a_tres_camp6 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_tres_camp7"
                                                value={obj_anexo_3?.a_tres_camp7 === null ? '' : obj_anexo_3?.a_tres_camp7.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_tres_camp7}
                                                helperText={error_a_tres_camp7 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                                <StyledTableCell>
                                    {
                                        obj_anexo_cabecalho_lista.length === 0 || obj_anexo_cabecalho_lista === undefined ?
                                            <></>
                                            :
                                            <CustomTextField
                                                name="a_tres_camp8"
                                                value={obj_anexo_3?.a_tres_camp8 === null ? '' : obj_anexo_3?.a_tres_camp8.toString().replace('.', ',')}
                                                onChange={onInputChange_3}
                                                error={error_a_tres_camp8}
                                                helperText={error_a_tres_camp8 ? "Apenas números são aceites" : ""}

                                            />
                                    }
                                </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableCell>A1+A2+A3</StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp1 === null ? '' : obj_anexo_3?.soma_camp1.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>

                                    {obj_anexo_3?.soma_camp2 === null ? '' : obj_anexo_3?.soma_camp2.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp3 === null ? '' : obj_anexo_3?.soma_camp3.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp4 === null ? '' : obj_anexo_3?.soma_camp4.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp5 === null ? '' : obj_anexo_3?.soma_camp5.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp6 === null ? '' : obj_anexo_3?.soma_camp6.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp7 === null ? '' : obj_anexo_3?.soma_camp7.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                    {obj_anexo_3?.soma_camp8 === null ? '' : obj_anexo_3?.soma_camp8.toString().replace('.', ',')}

                                </StyledTableCell>
                            </TableRow>
                        </>

                    );
                } else {
                    return (

                        <>
                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        textAlign: "left",
                                    }}
                                >
                                    A1 - Total de ferilizantes Orgânicos (só efluentes
                                    pecuários
                                    <Stack direction="row" justifyContent="start">
                                        e seus equiparados)
                                        <Box margin={-1} padding={0}>
                                            <BasicPopover
                                                text={
                                                    "O beneficiário deve, por cada um dos nutrientes listados, somar as quantidades\n a disponibilizar através dos tipos de fertilizantes orgânicos listados no campo «nutrientes a disponibilizar por tipo de fertilizantes». "
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp1 === null ? '0,00' : row.a_um_camp1.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp2 === null ? '0,00' : row.a_um_camp2.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp3 === null ? '0,00' : row.a_um_camp3.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp4 === null ? '0,00' : row.a_um_camp4.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp5 === null ? '0,00' : row.a_um_camp5.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp6 === null ? '0,00' : row.a_um_camp6.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp7 === null ? '0,00' : row.a_um_camp7.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_um_camp8 === null ? '0,00' : row.a_um_camp8.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell
                                    rowSpan={4}
                                    sx={{ alignItems: "center", justifyContent: "end" }}
                                >
                                    {is_historico === true ? <></> :

                                        <ButtonCadernos
                                            mostrarBotaoEditar
                                            aoClicarEditar={() => {
                                                set_obj_anexo(undefined)
                                                set_obj_anexo_3(row)
                                            }}
                                            mostrarBotaoApagar
                                            aoClicarApagar={() => {
                                                set_obj_anexo_3(row)
                                                set_open_dialog_tem_a_certeza_que_quer_eliminar_3(true)
                                            }}
                                        />}
                                </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        textAlign: "left",
                                    }}
                                >
                                    A2 - Total de outros fertilizantes orgânicos não
                                    contabilizados
                                    <Stack direction="row" justifyContent="start">
                                        em A1
                                        <Box margin={-1} padding={0}>
                                            <BasicPopover
                                                text={
                                                    "O beneficiário deve, por cada um dos nutrientes listados, somar as quantidades\n a disponibilizar através dos tipos de outros fertilizantes orgânicos listados no campo «nutrientes a disponibilizar por tipo de fertilizantes». "
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp1 === null ? '0,00' : row.a_dois_camp1.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp2 === null ? '0,00' : row.a_dois_camp2.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp3 === null ? '0,00' : row.a_dois_camp3.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp4 === null ? '0,00' : row.a_dois_camp4.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp5 === null ? '0,00' : row.a_dois_camp5.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp6 === null ? '0,00' : row.a_dois_camp6.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp7 === null ? '0,00' : row.a_dois_camp7.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.a_dois_camp8 === null ? '0,00' : row.a_dois_camp8.toString().replace('.', ',')} </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        textAlign: "left",
                                    }}
                                >
                                    A3 - Total de fertilizantes não
                                    <Stack direction="row" justifyContent="start">
                                        orgânicos
                                        <Box margin={-1} padding={0}>
                                            <BasicPopover
                                                text={
                                                    "O beneficiário deve, por cada um dos nutrientes listados, somar as quantidades\n a disponibilizar através dos tipos de fertilizantes não orgânicos listados no campo «nutrientes a disponibilizar por tipo de fertilizantes». "
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp1 === null ? '0,00' : row.a_tres_camp1.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp2 === null ? '0,00' : row.a_tres_camp2.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp3 === null ? '0,00' : row.a_tres_camp3.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp4 === null ? '0,00' : row.a_tres_camp4.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp5 === null ? '0,00' : row.a_tres_camp5.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp6 === null ? '0,00' : row.a_tres_camp6.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp7 === null ? '0,00' : row.a_tres_camp7.toString().replace('.', ',')}</StyledTableCell>
                                <StyledTableCell>{row.a_tres_camp8 === null ? '0,00' : row.a_tres_camp8.toString().replace('.', ',')}</StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableCell>
                                    <Stack direction="row" justifyContent="start">
                                        A1+A2+A3
                                        <Box margin={-1} padding={0}>
                                            <BasicPopover
                                                text={
                                                    "Este somatório, por cada um dos nutrientes, não pode ser superior aos valores determinados no campo «Previsão total de nutrientes a disponibilzar à cultura» do «Quadro 3 - Plano de aplicação»."
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </StyledTableCell>
                                <StyledTableCell>{row.soma_camp1 === null ? '0,00' : row.soma_camp1.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp2 === null ? '0,00' : row.soma_camp2.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp3 === null ? '0,00' : row.soma_camp3.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp4 === null ? '0,00' : row.soma_camp4.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp5 === null ? '0,00' : row.soma_camp5.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp6 === null ? '0,00' : row.soma_camp6.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp7 === null ? '0,00' : row.soma_camp7.toString().replace('.', ',')} </StyledTableCell>
                                <StyledTableCell>{row.soma_camp8 === null ? '0,00' : row.soma_camp8.toString().replace('.', ',')} </StyledTableCell>
                            </TableRow>
                        </>

                    );
                }
            })}

            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                onConfirm={handle_delete_anexo}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar_cabecalho}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_cabecalho(false)}
                onConfirm={handle_delete_anexo_cabecalho}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar_3}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_3(false)}
                onConfirm={handle_delete_anexo_3}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_cabecalho}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_cabecalho(false)}
                onConfirm={() => handleCloseDialog_cabecalho()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_3}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_3(false)}
                onConfirm={() => handleCloseDialog_3()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </TableContainer>
    );
};